import { IconHideImage } from '@tvg/fuse-icons';
import PropTypes from 'prop-types';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import styled from 'styled-components';
import { global } from '../../fuse-colours/src/colours';

const propTypes = {
	alt: PropTypes.string.isRequired,
	isAltReal: PropTypes.bool,
};
const defaultProps = {
	isAltReal: false,
};

const StyledDefaultImg = styled.img`
	object-fit: cover;
	max-width: 100%;
	min-width: 100%;
`;

const MissingImage = styled.span`
	display: flex;

	aspect-ratio: 3 / 4;
	@supports not (aspect-ratio: 3 / 4) {
		&:before {
			content: '';
			padding-top: calc(4 / 3 * 100%);
		}
	}

	align-items: stretch;
	justify-content: center;
	position: relative;

	&:after {
		content: '';
		width: 40%;

		aspect-ratio: 1 / 1;
		@supports not (aspect-ratio: 1 / 1) {
			height: 30%;
		}

		display: block;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		background: ${`url('data:image/svg+xml, ${encodeURIComponent(
		renderToStaticMarkup(<IconHideImage />),
	)}')`};
		opacity: 0.2;
	}
`;

function DefaultImage({ alt, isAltReal, ...props }) {
	const src = `data:image/svg+xml, ${encodeURIComponent(
		`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1">
            <path d="M0 0h1v1H0" fill="${global.grey400}"/>
        </svg>`,
	)}`;

	return (
		<MissingImage {...props}>
			<StyledDefaultImg src={src} alt={alt} aria-hidden={isAltReal ? undefined : 'true'} />
		</MissingImage>
	);
}

DefaultImage.propTypes = propTypes;
DefaultImage.defaultProps = defaultProps;

export default DefaultImage;
